
namespace RecordShield.Workspace {

    @Serenity.Decorators.registerClass()
    export class SubscriberGrid extends Serenity.EntityGrid<SubscriberRow, any> {
        protected getColumnsKey() { return 'Workspace.Subscriber'; }
        protected getDialogType() { return SubscriberDialog; }
        protected getIdProperty() { return SubscriberRow.idProperty; }
        protected getLocalTextPrefix() { return SubscriberRow.localTextPrefix; }
        protected getService() { return SubscriberService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        private rowSelection: Serenity.GridRowSelectionMixin;
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            if (!Authorization.hasPermission("Administration:Security")) {
                filters.splice(Q.indexOf(filters, x => x.field == "TenantId"), 1);
                filters.splice(Q.indexOf(filters, x => x.field == "InsertDate"), 1);
            }
            return filters;
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        protected getButtons() {
            // preserving default New Item button
            var buttons = super.getButtons();
            buttons = buttons.slice(1);
           
                buttons.push({
                    title: 'Unblock User',
                    cssClass: 'edit-button',
                    onClick: () => {
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        if (rowKeys.length == 0 || rowKeys.length > 1) {
                            Q.alert("Please select single User to Unblock!");
                            return;
                        }
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        var key = this.rowSelection.getSelectedKeys()[0];
                        var entity;
                        RecordShield.Workspace.SubscriberService.Retrieve({
                            EntityId: key
                        }, response => {
                            entity = response.Entity;
                            Q.serviceRequest('Workspace/Subscriber/UnblockUser', {
                                EntityId: key,
                                Entity: entity
                            }, (response) => {
                                this.rowSelection.resetCheckedAndRefresh();
                                    this.refresh();
                                    Q.notifySuccess("Unblocked Successfully");
                            });
                        });
                    }
                });
           
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: SubscriberService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            return buttons;
        }
    }
}